import { Injectable } from '@angular/core';
import { Maybe } from '@orderna/admin-panel/src/types/maybe';
import { QueryOptions } from '@orderna/admin-panel/src/types/query-options';
import {
  Data,
  filterItems,
  getTotalItems,
} from '@orderna/admin-panel/src/utils/service';
import { BehaviorSubject, Observable } from 'rxjs';
import { fetchDiscountedTransactions } from '../../../../data/discounted-transactions';
import {
  DiscountedTransaction,
  IDiscountedTransaction,
} from '../../../../model/discounted-transaction';
import { IDiscountedTransactionsApiService } from './discounted-transactions-api.interface';
import { HandleBlobHttpResponseOptions } from '@orderna/admin-panel/src/types/handle-blob-http-response-options';
import { ExportDiscountedTransactionsQueryDto } from './dtos/export-discounted-transactions.query.dto';
import { FindDiscountedTransactionsQueryDto } from './dtos/find-discounted-transactions.query.dto';
import { FindDiscountedTransactionsResponseDto } from './dtos/find-discounted-transactions.response.dto';

@Injectable({
  providedIn: 'root',
})
export class DiscountedTransactionsMockApiService
  implements IDiscountedTransactionsApiService
{
  data = {
    discounted_transactions: {
      items: [] as DiscountedTransaction[],
      queryOptions: {
        page: 1,
        size: 10,
      } as QueryOptions<IDiscountedTransaction>,
      subject: new BehaviorSubject<Maybe<DiscountedTransaction[]>>(null),
      totalSubject: new BehaviorSubject<Maybe<number>>(null),
      totalAfterFilterSubject: new BehaviorSubject<Maybe<number>>(null),
    },
  };

  get discountedTransactionsData() {
    return this.data['discounted_transactions'] as Data<
      DiscountedTransaction,
      IDiscountedTransaction
    >;
  }

  findDiscountedTransactions(query: FindDiscountedTransactionsQueryDto): Promise<FindDiscountedTransactionsResponseDto> {
    throw new Error('Method not implemented.');
  }
  exportDiscountedTransactions(query: ExportDiscountedTransactionsQueryDto, options?: HandleBlobHttpResponseOptions): void {
    throw new Error('Method not implemented.');
  }
}
